import React from 'react'

export default function PlainLink(props) {
  return (
    <a className='white f5 lh-1-6 b dim no-underline' href={props.href}>
      {props.children}
    </a>
  )
}